/* eslint-disable no-console */
import Skycon from '@/components/Skycon/Skycon'
import { Chrome } from 'vue-color'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import DataModal from '../components/DataModal'
import config from '../../../config'
import { formatDate } from '../../../helper/helpernew'

export default {
  name: 'announcement',
  components: {
    Skycon,
    Chrome,
    vSelect,
    DatePicker,
    DataModal,
  },
  data() {
    return {
      data: [],
      columnsDatatable: ['no', 'title', 'image', 'author', 'created_at', 'updated_at', 'aksi'],
      tableOptions: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { no: 'width-100', title: 'text-wrap', description: 'text-wrap' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
      },
      editData: null,
    }
  },
  computed: {
    dataTable() {
      return this.data
        .sort((a, b) => a.id - b.id)
        .reduce(
          (acc, item, idx) => [
            ...acc,
            {
              ...item,
              index: idx,
              no: idx + 1,
              image: config.webprofileApiUrl + '/company-profile/' + item.imageUrl,
            },
          ],
          [],
        )
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    formatDate,
    async getData() {
      const res = await axios.get(config.webprofileApiUrl + '/company-profile/announcement')

      if (res.data) {
        this.data = res.data.data
      }
    },
    handleAdd() {
      this.$router.push(`/app/web/announcement/detail`)
    },
    handleEdit(index) {
      const id = this.dataTable[index].id

      this.$router.push(`/app/web/announcement/detail/${id}`)
    },
    async handleDelete(index) {
      const id = this.dataTable[index].id

      if (confirm('Are you sure to delete?')) {
        try {
          await axios({
            method: 'delete',
            url: config.webprofileApiUrl + `/company-profile/announcement/${id}`,
            headers: { 'Content-Type': 'multipart/form-data' },
          })

          this.$toasted.success('Berhasil Dihapus')
        } catch (err) {
          this.$toasted.error('Gagal Dihapus')
        } finally {
          this.getData()
        }
      }
    },
  },
}
